import { getState } from '../store';

export type Page = 'Home' | 'Categories' | 'Chatbot' | 'Category' | 'Search' | 'Article';

const PageMap: Record<Page, string> = {
  Home: 'home',
  Category: 'category',
  Categories: 'categories',
  Article: 'article',
  Search: 'search_results',
  Chatbot: 'chatbot',
};

export const pageEnumToString = (page: Page): string => {
  return PageMap[page];
};

const getPageFromUrl = (url: string): Page => {
  try {
    let pathname: string;
    try {
      const urlObj = new URL(url);
      pathname = urlObj.pathname;
    } catch {
      pathname = url;
    }

    if (pathname.includes('/chatbot')) {
      return 'Chatbot';
    } else if (pathname.includes('/search')) {
      return 'Search';
    } else if (pathname.includes('/article/id/') || pathname.includes('/article/uri/')) {
      return 'Article';
    } else if (pathname.includes('/category')) {
      return 'Category';
    } else if (pathname.includes('/categories')) {
      return 'Categories';
    } else {
      return 'Home';
    }
  } catch (e) {
    return 'Home';
  }
};

export const getCurrentPage = (): Page => {
  const {
    widget: { currentUrl },
    widgetIframeSrc,
  } = getState();

  if (currentUrl) {
    return getPageFromUrl(currentUrl);
  }
  if (widgetIframeSrc) {
    return getPageFromUrl(widgetIframeSrc);
  }

  return 'Home';
};
